import { BlockConfigData } from './types'

const wrapInCommonStyles = (content: string, data: BlockConfigData): string => {
  const bgColor = data.backgroundColor || 'transparent'
  const paddingTop = data.paddingTop || '20px'
  const paddingBottom = data.paddingBottom || '20px'
  const paddingLeft = data.paddingLeft || '20px'
  const paddingRight = data.paddingRight || '20px'
  const align = data.align || 'center'
  
  const borderWidth = data.borderWidth || '0px'
  const borderStyle = data.borderStyle || 'solid'
  const borderColor = data.borderColor || '#dddddd'
  const borderRadius = data.borderRadius || '0px'

  const borderCss = borderWidth !== '0px' ? `border: ${borderWidth} ${borderStyle} ${borderColor};` : ''
  const borderRadiusCss = borderRadius !== '0px' ? `border-radius: ${borderRadius};` : ''

  return `
    <table width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background-color: ${bgColor};">
      <tr>
        <td align="${align}" style="padding: ${paddingTop} ${paddingRight} ${paddingBottom} ${paddingLeft};">
          <table width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="max-width: 900px; margin: 0 auto; ${borderCss} ${borderRadiusCss} overflow: hidden;">
            <tr>
              <td>
                ${content}
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  `
}

export const generateBlockHTML = (blockId: string, data: BlockConfigData): string => {
  let content = ''
  
  switch (blockId) {
    case 'header_simple':
      content = `
        <div align="center" style="padding: 0;">
          ${data.logoUrl ? `<img src="${data.logoUrl}" alt="Logo" style="width: ${data.logoWidth || '150px'}; height: ${data.logoHeight || 'auto'}; display: block; margin: 0 auto;" />` : '<div style="font-family: sans-serif; font-size: 24px; font-weight: bold; color: #333;">Logo</div>'}
        </div>
      `
      break;

    case 'social_links':
      const networks = [
        { key: 'socialFb', icon: 'https://img.icons8.com/color/48/facebook-new.png', label: 'Facebook' },
        { key: 'socialIg', icon: 'https://img.icons8.com/color/48/instagram-new.png', label: 'Instagram' },
        { key: 'socialIn', icon: 'https://img.icons8.com/color/48/linkedin.png', label: 'LinkedIn' },
        { key: 'socialX', icon: 'https://img.icons8.com/color/48/twitterx--v1.png', label: 'X' },
        { key: 'socialYt', icon: 'https://img.icons8.com/color/48/youtube-play.png', label: 'YouTube' },
        { key: 'socialWa', icon: 'https://img.icons8.com/color/48/whatsapp.png', label: 'WhatsApp' },
      ]
      
      const iconSize = data.socialSize || '32px'
      const activeNetworks = networks.filter(n => data[n.key as keyof BlockConfigData])
      
      if (activeNetworks.length === 0) {
        content = ''
        break
      }
      
      const iconsHtml = activeNetworks.map(n => `
        <td style="padding: 0 8px;">
          <a href="${data[n.key as keyof BlockConfigData]}" target="_blank">
            <img src="${n.icon}" alt="${n.label}" width="${iconSize}" style="display: block; border: 0;" />
          </a>
        </td>
      `).join('')
      
      content = `
        <div align="${data.align || 'center'}" style="padding: 0;">
          <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="display: inline-table;">
            <tr>
              ${iconsHtml}
            </tr>
          </table>
        </div>
      `
      break;

    case 'footer_copyright':
      content = `
        <div align="center" style="font-family: sans-serif; font-size: 14px; line-height: 1.6; color: #6c757d;">
          <p style="margin: 0 0 10px 0;">
            ${data.copyrightText || `© ${new Date().getFullYear()} Todos los derechos reservados.`}
          </p>
          <p style="margin: 0;">
            <a href="{{unsubscribe_url}}" style="color: #007bff; text-decoration: underline;">
              ${data.unsubscribeText || 'Cancelar suscripción'}
            </a>
          </p>
        </div>
      `
      break;

    case 'hero':
      // Build hero image styles
      let heroImageStyle = 'display: block;'
      if (data.imageWidth) {
        heroImageStyle += ` width: ${data.imageWidth};`
      } else {
        heroImageStyle += ' width: 100%; max-width: 900px;'
      }
      if (data.imageHeight) {
        heroImageStyle += ` height: ${data.imageHeight};`
      } else {
        heroImageStyle += ' height: auto;'
      }

      content = `
        <div style="text-align: center;">
          ${data.imageUrl ? `<img src="${data.imageUrl}" alt="${data.imageAlt || 'Hero'}" style="${heroImageStyle}" />` : ''}
          <div style="padding: ${data.padding || '40px 30px'}; text-align: center;">
            ${data.title ? `<h1 style="margin: 0 0 20px 0; color: #333; font-size: 36px; font-family: sans-serif;">${data.title}</h1>` : ''}
            ${data.subtitle ? `<p style="margin: 0 0 25px 0; color: #666; font-size: 22px; line-height: 1.6; font-family: sans-serif;">${data.subtitle}</p>` : ''}
            ${data.buttonText && data.buttonUrl ? `
              <a href="${data.buttonUrl}" style="background-color: ${data.buttonColor || '#007bff'}; color: #ffffff; padding: 12px 25px; text-decoration: none; border-radius: 5px; display: inline-block; font-weight: bold; font-family: sans-serif;">
                ${data.buttonText}
              </a>
            ` : ''}
          </div>
        </div>
      `;
      break;

    case '1_col':
      content = `
        <div style="font-family: sans-serif; font-size: 20px; line-height: 1.6; color: #333333;">
          ${data.content || '<p style="margin: 0; font-size: 20px;">Escribe tu contenido aquí...</p>'}
        </div>
      `;
      break;
      
    case '2_cols':
      content = `
        <table width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation">
          <tr>
            <td width="${data.col1Width || '50%'}" valign="top" style="padding: 10px; background-color: ${data.col1BackgroundColor || 'transparent'}; border: ${data.col1Border || 'none'};">
              <div style="font-family: sans-serif; font-size: 14px; line-height: 1.5; color: #444444;">
                ${data.col1Content || 'Columna 1'}
              </div>
            </td>
            <td width="${data.col2Width || '50%'}" valign="top" style="padding: 10px; background-color: ${data.col2BackgroundColor || 'transparent'}; border: ${data.col2Border || 'none'};">
              <div style="font-family: sans-serif; font-size: 14px; line-height: 1.5; color: #444444;">
                ${data.col2Content || 'Columna 2'}
              </div>
            </td>
          </tr>
        </table>
      `;
      break;
      
    case '3_cols':
      content = `
        <table width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation">
          <tr>
            <td width="${data.col1Width || '33.33%'}" valign="top" style="padding: 10px; background-color: ${data.col1BackgroundColor || 'transparent'}; border: ${data.col1Border || 'none'};">
              <div style="font-family: sans-serif; font-size: 14px; line-height: 1.4; color: #444444;">
                ${data.col1Content || 'C1'}
              </div>
            </td>
            <td width="${data.col2Width || '33.33%'}" valign="top" style="padding: 10px; background-color: ${data.col2BackgroundColor || 'transparent'}; border: ${data.col2Border || 'none'};">
              <div style="font-family: sans-serif; font-size: 14px; line-height: 1.4; color: #444444;">
                ${data.col2Content || 'C2'}
              </div>
            </td>
            <td width="${data.col3Width || '33.33%'}" valign="top" style="padding: 10px; background-color: ${data.col3BackgroundColor || 'transparent'}; border: ${data.col3Border || 'none'};">
              <div style="font-family: sans-serif; font-size: 14px; line-height: 1.4; color: #444444;">
                ${data.col3Content || 'C3'}
              </div>
            </td>
          </tr>
        </table>
      `;
      break;

    case 'image_text':
      content = `
        <table width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation">
          <tr>
            <td width="50%" valign="middle" style="padding: 10px;">
              ${data.imageUrl ? `<img src="${data.imageUrl}" alt="Image" style="width: 100%; height: auto; border-radius: 4px; display: block;" />` : '<div style="background:#eee; height: 150px; display:flex; align-items:center; justify-content:center; font-family: sans-serif;">Image</div>'}
            </td>
            <td width="50%" valign="middle" style="padding: 10px; font-family: sans-serif; text-align: left;">
              <h3 style="margin: 0 0 10px 0; color: #333;">${data.title || 'Heading'}</h3>
              <p style="margin: 0 0 15px 0; color: #666; line-height: 1.5;">${data.content || 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'}</p>
              ${data.buttonText && data.buttonUrl ? `<a href="${data.buttonUrl}" style="color: ${data.buttonColor || '#007bff'}; font-weight:bold; text-decoration: none;">${data.buttonText} →</a>` : ''}
            </td>
          </tr>
        </table>
      `;
      break;

    case 'button':
      const btnPadding = `${data.buttonPaddingVertical || '12px'} ${data.buttonPaddingHorizontal || '25px'}`
      const alignment = data.align || 'center'
      const placement = data.buttonPlacement || 'below'
      
      const titleHtml = data.title ? `<h2 style="margin: 0 0 10px 0; font-family: sans-serif; font-size: 24px; color: #333;">${data.title}</h2>` : ''
      const contentHtml = data.content ? `<div style="margin: 0 0 20px 0; font-family: sans-serif; font-size: 16px; color: #666; line-height: 1.5;">${data.content}</div>` : ''
      const buttonHtml = `
        <a href="${data.buttonUrl || '#'}" style="background-color: ${data.buttonColor || '#007bff'}; color: ${data.color || '#ffffff'}; padding: ${btnPadding}; text-decoration: none; border-radius: ${data.borderRadius || '5px'}; display: inline-block; font-weight: bold; font-family: sans-serif; font-size: ${data.fontSize || '16px'}; ${data.buttonWidth ? `width: ${data.buttonWidth}; box-sizing: border-box; text-align: center;` : ''}">
          ${data.buttonText || 'Click Here'}
        </a>
      `

      if (alignment === 'center') {
        const first = placement === 'above' ? buttonHtml : (titleHtml + contentHtml)
        const second = placement === 'above' ? (titleHtml + contentHtml) : buttonHtml
        const spacing = (placement === 'above' && data.title) ? '20px' : '0'
        
        content = `
          <div style="text-align: center;">
            <div style="margin-bottom: ${spacing};">${first}</div>
            <div>${second}</div>
          </div>
        `
      } else {
        const textCell = `<td style="vertical-align: middle;">${titleHtml}${contentHtml}</td>`
        const buttonCell = `<td style="vertical-align: middle; padding-${alignment === 'left' ? 'left' : 'right'}: 20px;" width="1%" nowrap>${buttonHtml}</td>`
        const firstCell = alignment === 'left' ? textCell : buttonCell
        const secondCell = alignment === 'left' ? buttonCell : textCell
        
        content = `
          <table width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation">
            <tr>
              ${firstCell}
              ${secondCell}
            </tr>
          </table>
        `
      }
      break;
      
    case 'divider':
      content = `<hr style="border: 0; border-top: 1px solid #dee2e6; margin: 0;" />`
      break;
      
    case 'spacer':
      const spacerHeight = data.spacerHeight || '40px'
      content = `<div style="height: ${spacerHeight};">&nbsp;</div>`
      break;
      
    case 'image':
      if (!data.imageUrl) {
        content = ''
        break
      }
      
      const imageStyles: string[] = []
      if (data.imageWidth) {
        imageStyles.push(`width: ${data.imageWidth}`)
      } else {
        imageStyles.push('max-width: 100%')
      }
      if (data.imageHeight) {
        imageStyles.push(`height: ${data.imageHeight}`)
      } else {
        imageStyles.push('height: auto')
      }
      imageStyles.push('display: block')
      imageStyles.push(`border-radius: ${data.borderRadius || '0px'}`)
      
      const imageStyleString = imageStyles.join('; ')
      
      content = `
        <div style="text-align: center; margin: 0;">
          <img src="${data.imageUrl}" alt="${data.imageAlt || ''}" style="${imageStyleString};" />
        </div>
      `
      break;

    default:
      content = ''
  }

  return wrapInCommonStyles(content, data)
}
